import apiService from 'src/enviroment';

const getTotalMarkes = async (number, year) => {
  try {
    const response = await apiService.get(
      `/junta/comercial/mercadodemotos/${number}/?yyyy=${year}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMarketShare = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/comercial/marketshare/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMarketShareByTerritory = async (number, year, territory) => {
  try {
    const response = await apiService.get(
      `/junta/comercial/marketshare/${number}/?yyyy=${year}&territorio=${territory}`,
    );
    if (response.status === 200) {
      return [{ ...response.data, territorio: territory }];
    }
    return [];
  } catch (error) {
    return false;
  }
};

const getTotalMarketShareByTerritoryGrapics = async (
  number,
  year,
  territory,
) => {
  try {
    const response = await apiService.get(
      `/junta/comercial/marketsharegraficas/${number}/?yyyy=${year}&territorio=${territory}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
    return [];
  } catch (error) {
    return false;
  }
};

const getTotalMarketsGraphics = async (number, year) => {
  try {
    const response = await apiService.get(
      `/junta/comercial/mercadodemotosgraficas/${number}/?yyyy=${year}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMarketShareGraphics = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/comercial/marketsharegraficas/${number}/?yyyy=${year}&${
        param || null
      }`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMEI = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/mei/meirunt/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const graphicsTotalMEI = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/mei/gmeirunt/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalSalesMEI = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/mei/meiventas/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const graphicsTotalSalesMEI = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/mei/gmeiventas/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMarket4W = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/4w/w4total/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getGTotalMarket4W = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/4w/gw4total/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMarket4WProduct = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/4w/w4mercado/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getGTotalMarket4WProduct = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/4w/gw4mercado/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalMarket3WProduct = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/3w/w3mercado/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getGTotalMarket3WProduct = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/3w/g3w/${number}/?yyyy=${year}&${param || null}`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getTotalImports = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/importaciones/repimportaciones/${number}/?yyyy=${year}&${
        param || null
      }`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const getGTotalImports = async (number, year, param) => {
  try {
    const response = await apiService.get(
      `/junta/importaciones/grepimportaciones/${number}/?yyyy=${year}&${
        param || null
      }`,
    );
    if (response.status === 200) {
      return response.data.datos;
    }
  } catch (error) {
    return false;
  }
};

const uploadFile = async (body) => {
  try {
    const response = await apiService.post('/junta/archivos/', body);
    if (response.status === 200) {
      return response.data.success;
    }
  } catch (error) {
    return false;
  }
};

const prevUploadFile = async (body) => {
  const { seccion, yyyy, mm } = body;
  try {
    const response = await apiService.get(
      `/junta/archivos/?seccion=${seccion}&yyyy=${yyyy}&mm=${mm}`,
    );
    if (response.status === 200) {
      return response.data.archivos;
    }
  } catch (error) {
    return false;
  }
};

const boardReportsService = {
  uploadFile,
  prevUploadFile,
  getTotalImports,
  getGTotalImports,
  getGTotalMarket4W,
  getGTotalMarket4WProduct,
  getTotalMarket3WProduct,
  getGTotalMarket3WProduct,
  getTotalMarket4W,
  graphicsTotalMEI,
  getTotalSalesMEI,
  graphicsTotalSalesMEI,
  getTotalMEI,
  getTotalMarkes,
  getTotalMarketShare,
  getTotalMarket4WProduct,
  getTotalMarketsGraphics,
  getTotalMarketShareGraphics,
  getTotalMarketShareByTerritory,
  getTotalMarketShareByTerritoryGrapics,
};

export default boardReportsService;
